// Color configuration for the application
export const config = {
  colors: {
    fieldBg: '#ffffff',
    fieldBorder: '#d1d5db',
    nodeBg: '#f3f4f6',
    nodeBorder: '#9ca3af',
    canvas: '#fafafa',
    edges: '#6b7280',
    accent: '#3b82f6',
    
    // Text colors
    textPrimary: '#1f2937',
    textSecondary: '#6b7280',
    textMuted: '#9ca3af',
    textAccent: '#3b82f6',
    
    // Picker colors
    pickerBg: '#ffffff',
    pickerBorder: '#e5e7eb',
    pickerHover: '#f9fafb',
    pickerSelected: '#eff6ff',
    pickerSelectedBorder: '#3b82f6'
  },
  
  // Field type colors
  fieldTypes: {
    note: {
      bg: '#dbeafe',
      border: '#93c5fd',
      icon: '#3b82f6',
      button: '#3b82f6',
      buttonHover: '#2563eb'
    },
    variable: {
      bg: '#dcfce7',
      border: '#86efac',
      icon: '#22c55e',
      button: '#22c55e',
      buttonHover: '#16a34a'
    },
    calculation: {
      bg: '#e9d5ff',
      border: '#c084fc',
      icon: '#a855f7',
      button: '#a855f7',
      buttonHover: '#9333ea'
    }
  }
};


// productsConfig.js
export const products = [
  {
    id: 1,
    name: 'Borsa',
    price: 199.99,
    image: 'https://via.placeholder.com/150?text=Headphones',
    description: 'High-quality noise cancelling headphones'
  },
  {
    id: 2,
    name: 'Spilla',
    price: 89.99,
    image: 'https://via.placeholder.com/150?text=Keyboard',
    description: 'Ergonomic mechanical keyboard with RGB lighting'
  },
  {
    id: 3,
    name: 'Cintura',
    price: 299.99,
    image: 'https://via.placeholder.com/150?text=Smart+Watch',
    description: 'Fitness tracking smartwatch with heart rate monitor'
  }
];

